import { render, staticRenderFns } from "./GanjoorLinks.vue?vue&type=template&id=1566147a&scoped=true&"
import script from "./GanjoorLinks.vue?vue&type=script&lang=js&"
export * from "./GanjoorLinks.vue?vue&type=script&lang=js&"
import style0 from "./GanjoorLinks.vue?vue&type=style&index=0&id=1566147a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1566147a",
  null
  
)

export default component.exports